import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { cn } from '@gto/ui/cn'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'

import { useAuth } from '@/hooks/use-auth'
import { DealsSection } from '@/pages/home/components/deals-section'
import { EarningsTable } from '@/pages/rewards/components/earnings-table'
import { EmailVerificationForm } from '@/pages/rewards/components/email-verification-form'
import { RewardsPageHeader } from '@/pages/rewards/components/rewards-page-header'
import { RewardsStats } from '@/pages/rewards/components/rewards-stats'

export const RewardsRootRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { emailValidated } = useAuth()

  return (
    <div
      className={cn('flex flex-col', isSmAndLower ? 'gap-8' : 'gap-14')}
      data-tst="rewards-page"
    >
      <div className="flex flex-col gap-8">
        <RewardsPageHeader />
        {emailValidated ? <RewardsStats /> : <EmailVerificationForm />}
      </div>
      {emailValidated && (
        <>
          <EarningsTable period="this_month" />
          <EarningsTable period="last_month" />
          <div className="flex flex-col items-center">
            <Button
              viewTransition
              color="secondary"
              component={Link}
              size="large"
              to="/app/rewards/edge-history"
              variant="contained"
            >
              <FormattedMessage id="common.controls.viewEdgeHistory" />
            </Button>
          </div>
          <DealsSection homePage={false} />
        </>
      )}
    </div>
  )
}
